import { ModelApiService } from './BaseApiService'

export default class BookingsApiService extends ModelApiService {
  constructor() {
    super('bookings')
  }

  async getFeedbackFormUrl(bookingId) {
    return await this.get(`${bookingId}/feedback-form`)
  }

  async submitQuickFeedback(bookingId, data) {
    return await this.post(`${bookingId}/quick-feedback`, data)
  }

  async checkReplaceMeStatus(clientId) {
    return await this.get('replace-me-status', { clientId })
  }

  async submitReplaceMeBooking(payload) {
    return await this.post('replaceMe', payload)
  }

  async cancelBooking(bookingId, payload) {
    return await this.post(`${bookingId}/cancel`, payload)
  }
}
